const e=e=>{const{schema:s,output:t="schema.graphql",...a}=e;return{schema:s,...a,generates:{[t]:{plugins:["schema-ast"]}}}};export{e as getConfig};
